import { CurrencyConfig } from "../AppConstants";

const size = {
  mobileS: "320px",
  mobileM: "375px",
  mobileL: "425px",
  tablet: "768px",
  laptop: "1024px",
  laptopL: "1440px",
  desktop: "2560px",
};

const device = {
  mobileS: `(min-width: ${size.mobileS})`,
  mobileM: `(min-width: ${size.mobileM})`,
  mobileL: `(min-width: ${size.mobileL})`,
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopL: `(min-width: ${size.laptopL})`,
  desktop: `(min-width: ${size.desktop})`,
  desktopL: `(min-width: ${size.desktop})`,
};

const convertToCurrencyFormat = (locale, currencyNumber) => {
  let _result = CurrencyConfig.find(config => config.locale === locale);
  let _localeOption = _result ? _result.option : { style: "currency", currency: "GBP", currencyDisplay: "symbol" };

  let formattedCurrency = currencyNumber.toLocaleString(locale.replace("_", "-"), _localeOption);

  // Ensure currency symbol is at the front
  let currencySymbol = new Intl.NumberFormat(locale.replace("_", "-"), { style: "currency", currency: _localeOption.currency })
    .formatToParts(0)
    .find(part => part.type === "currency")?.value;

  // If the symbol is not already in front, move it
  if (!formattedCurrency.startsWith(currencySymbol)) {
    formattedCurrency = `${currencySymbol} ${formattedCurrency.replace(currencySymbol, "").trim()}`;
  }

  return formattedCurrency;
};

const px2vw = (size, width = 1440) => `${(parseInt(size) / width) * 100}vw`;

export { device, px2vw, convertToCurrencyFormat };
